import { useLocale } from '@dreamstack/i18n'

export const useGetInvestorsLocaleForLink = () => {
  const locale = useLocale()
  return locale !== 'de' ? locale : ''
}
